import { HealthDetailPage } from '@/components/shared/ReuseableHealthDeatil';
import { useGetMyMicrobiomeDetail } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { MicrobiomeDetailResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { JourneyEducationTypes } from '@utils/JourneyEducationTypes';
import { getRichnessAnimation } from '@utils/health/getAnimation';
import { ErrorLoadingPage } from '../ErrorHandling/ErrorLoadingPage';
import GutRichness from '@/assets/microbiome_gut.json';

export const GutRichnessPage = () => {
  const { data, isLoading, isError } = useGetMyMicrobiomeDetail('gut');

  if (isError) {
    return <ErrorLoadingPage variant="dark" />;
  }

  if (!data?.richness) {
    return null;
  }

  const { richness }: MicrobiomeDetailResponse = data;

  return (
    <HealthDetailPage
      data={{
        title: richness.title,
        about: richness.about,
        mainStat: `${String(richness.percentage)}`,
        subStat: richness.rank,
        rankColor: richness.rank_color,
        size: 'lg',
        overlayImg: '',
        richnessTrend: richness.trend,
        fallBackVdo: GutRichness,
        videoSrc: getRichnessAnimation('gut'),
      }}
      isMainStatPercentage
      journeyDeeperSectionInfo={JourneyEducationTypes.GUT_MICROBIOME_DETAIL}
      isLoading={isLoading}
      screen="gut_richness"
    />
  );
};
